export default "__VITE_ASSET__BGOEfZmC__"